export default "__VITE_ASSET__a94eedfa__"